document.addEventListener('DOMContentLoaded', function() {

    // --- MODULE 1: INITIALIZATION AND ELEMENT SEARCH ---
    const form = document.getElementById('multi-step-form');
    const prevBtn = document.getElementById('prev-btn');
    const nextBtn = document.getElementById('next-btn');
    const submitBtn = document.getElementById('submit-btn');
    const steps = document.querySelectorAll('.form-step');
    const progressSteps = document.querySelectorAll('.progress-step');
    const orderInput = document.getElementById('amazon-order-input');
    const marketplaceSelect = document.getElementById('store'); 
    const messageDiv = document.getElementById('order-validation-message');

    const marketplaceTrigger = document.getElementById('gift_marketplace-trigger');
    const modalOverlay = document.getElementById('gift_modal-overlay');
    const marketplaceList = document.getElementById('gift_marketplace-list');
    const modalCloseBtn = document.getElementById('gift_modal-close');

    const noGiftCheckbox = document.getElementById('check2');
    const giftRadios = document.querySelectorAll('input[name="gift"]');
    const personalizationGroup = document.querySelector('.personalization-group');
    const personalizationYes = document.getElementById('personalization-yes');
    const personalizationNo = document.getElementById('personalization-no');
    const engravingInput = document.getElementById('engraving-input');
    const step3Heading = document.querySelector('#step-3 .f_heading');
    const phoneInput = document.getElementById('phone');
    const shippingOptionalFields = document.querySelectorAll('.shipping-optional');
    const countrySelect = document.getElementById('country');
    const stateSelect = document.getElementById('state');
    const stateWrapper = document.getElementById('state-wrapper');
    let currentStep = 0;
    let isItiReady = false;
    
    const iti = window.intlTelInput(phoneInput, {
        initialCountry: "us",
        preferredCountries: ["us", "ca", "gb", "de", "fr", "es", "it"],
        utilsScript: "https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js",
        allowDropdown: true,
        autoPlaceholder: "polite",
        nationalMode: false,
        showFlags: true,
        countrySearch: true
    });
    
    iti.promise.then(() => {
        isItiReady = true;
    }).catch(error => console.error("❌ Не удалось загрузить intl-tel-input utils.js:", error));

    fetch('https://ipapi.co/json/', { method: 'GET', mode: 'cors' })
        .then(response => response.ok ? response.json() : Promise.reject('Failed to fetch IP info'))
        .then(data => data?.country_code && iti.setCountry(data.country_code.toLowerCase()))
        .catch(err => console.warn('Could not fetch country code.', err));

    // --- MODULE 2: UI HELPER FUNCTIONS ---
    function updateProgress() {
        progressSteps.forEach((step, index) => {
            step.classList.remove('active', 'completed');
            if (index === currentStep) step.classList.add('active');
            else if (index < currentStep) step.classList.add('completed');
        });
    }
    
    function toggleEngravingInput() {
        const isYes = personalizationYes.checked;
        engravingInput.style.display = isYes ? 'block' : 'none';
        engravingInput.querySelector('input').required = isYes;
    }

    function updateFindOrderLink() {
        const selectedOption = marketplaceSelect.options[marketplaceSelect.selectedIndex];
        const storeLink = document.querySelector('.store_link a');

        if (!storeLink) return;

        if (selectedOption && selectedOption.value) {
            storeLink.href = selectedOption.getAttribute('data-orders-link') || '#';
            storeLink.classList.add('active');
        } else {
            storeLink.classList.remove('active');
            storeLink.href = '#';
        }
    }
    
    function updateAmazonStoreLink() {
        const goToAmazonButton = document.querySelector('.go_ama');
        if (!goToAmazonButton) return;
        
        const marketplaceLinks = {
            'ATVPDKIKX0DER': 'https://www.amazon.com/vantamo',
            'A2EUQ1WTGCTBG2': 'https://www.amazon.ca/stores/Vantamo/page/5009F4BC-B89A-482B-9CE9-0BAE5E8B4B61',
            'A1F83G8C2ARO7P': 'https://www.amazon.co.uk/stores/page/468EE773-6B33-445C-BF8E-B64075A65A08?ingress=3',
            'A1PA6795UKMFR9': 'https://www.amazon.de/stores/Vantamo/page/A7FF35CD-0B79-46E0-9C34-E907725537E8',
            'A1RKKUPIHCS9HS': 'https://www.amazon.es/stores/Vantamo/page/61CC0232-5D91-412E-B6E1-8F1D76B893F5',
            'APJ6JRA9NG5V4': 'https://www.amazon.it/stores/Vantamo/page/6E79423A-19F5-4369-8057-2FC0E3163109',
            'A13V1IB3VIYZZH': 'https://www.amazon.fr/stores/Vantamo/page/02A4DEE7-B8D3-4C50-B98C-F25013AB4FB5'
        };
        
        const selectedValue = marketplaceSelect.value;
        const amazonLink = marketplaceLinks[selectedValue] || 'https://www.amazon.com/vantamo';
        goToAmazonButton.href = amazonLink;
    }
    
    function toggleShippingFields() {
        const isNoGift = noGiftCheckbox.checked;
        
        shippingOptionalFields.forEach(field => field.style.display = isNoGift ? 'none' : '');
        personalizationGroup.style.display = isNoGift ? 'none' : '';

        const headingContainer = document.getElementById('step-3-heading-container');
        const withGiftTemplate = document.getElementById('text-template-step3-with-gift');
        const noGiftTemplate = document.getElementById('text-template-step3-no-gift');

        if (headingContainer && withGiftTemplate && noGiftTemplate) {
            if (isNoGift) {
                headingContainer.innerHTML = noGiftTemplate.innerHTML;
            } else {
                headingContainer.innerHTML = withGiftTemplate.innerHTML;
            }
        }
    }

    function showStep(stepIndex) {
        steps.forEach((step, index) => {
            step.classList.toggle('active', index === stepIndex);
        });

        prevBtn.style.display = (stepIndex > 0 && stepIndex < 3) ? 'flex' : 'none';
        nextBtn.style.display = stepIndex < 2 ? 'flex' : 'none';
        submitBtn.style.display = stepIndex === 2 ? 'flex' : 'none';
        
        nextBtn.classList.toggle('next-btn-full-width', stepIndex === 0);
        updateProgress();

        if (stepIndex === 3) {
            
            // --- 1. Smart slider initialization ---
            function initializeSliderWhenReady() {
                // Check if jQuery and Slick are loaded
                if (typeof jQuery !== 'undefined' && typeof jQuery.fn.slick !== 'undefined') {
                    const slider = $('.th_slider');
                    if (slider.length && !slider.hasClass('slick-initialized')) {
                        slider.slick({
                            dots: true,
                            infinite: false,
                            speed: 300,
                            slidesToShow: 4,
                            slidesToScroll: 4,
                            responsive: [
                                {
                                    breakpoint: 768,
                                    settings: {
                                        slidesToShow: 2,
                                        slidesToScroll: 2
                                    }
                                }
                            ]
                        });
                    }
                } else {
                    // If not ready, wait 100ms and try again
                    setTimeout(initializeSliderWhenReady, 100);
                }
            }
            
            // Start waiting and initialization process
            initializeSliderWhenReady();

            // --- 2. Update thank you text ---
            const subheadingContainer = document.getElementById('thank-you-subheading-container');
            const withGiftTemplate = document.getElementById('text-template-with-gift');
            const noGiftTemplate = document.getElementById('text-template-no-gift');
            const warrantyName = form.dataset.warrantyName || 'your warranty';

            if (noGiftCheckbox.checked) {
                subheadingContainer.innerHTML = noGiftTemplate.innerHTML.replace(/\[warranty_name\]/g, warrantyName);
            } else {
                subheadingContainer.innerHTML = withGiftTemplate.innerHTML.replace(/\[warranty_name\]/g, warrantyName);
            }

            // --- 3. Update Amazon Store button link ---
            updateAmazonStoreLink();
        }
    }
        
    const usStates = [
        { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' }, { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' }, { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'DC', name: 'District Of Columbia' }, { code: 'FL', name: 'Florida' }, { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' }, { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' }, { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' }, { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' }, { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' }, { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' }, { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' }, { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' }, { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' }, { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' }, { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' }, { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' }, { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' }, { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }
    ];
    const canadianProvinces = [
        { code: 'AB', name: 'Alberta' }, { code: 'BC', name: 'British Columbia' }, { code: 'MB', name: 'Manitoba' }, { code: 'NB', name: 'New Brunswick' }, { code: 'NL', name: 'Newfoundland and Labrador' }, { code: 'NS', name: 'Nova Scotia' }, { code: 'ON', name: 'Ontario' }, { code: 'PE', name: 'Prince Edward Island' }, { code: 'QC', name: 'Quebec' }, { code: 'SK', name: 'Saskatchewan' }
    ];
    const spanishProvinces = [
        { code: 'A Coruña', name: 'A Coruña' }, { code: 'Álava', name: 'Álava' }, { code: 'Albacete', name: 'Albacete' }, { code: 'Alicante', name: 'Alicante' }, { code: 'Almería', name: 'Almería' }, { code: 'Asturias', name: 'Asturias' }, { code: 'Ávila', name: 'Ávila' }, { code: 'Badajoz', name: 'Badajoz' }, { code: 'Baleares', name: 'Baleares' }, { code: 'Barcelona', name: 'Barcelona' }, { code: 'Burgos', name: 'Burgos' }, { code: 'Cáceres', name: 'Cáceres' }, { code: 'Cádiz', name: 'Cádiz' }, { code: 'Cantabria', name: 'Cantabria' }, { code: 'Castellón', name: 'Castellón' }, { code: 'Ciudad Real', name: 'Ciudad Real' }, { code: 'Córdoba', name: 'Córdoba' }, { code: 'Cuenca', name: 'Cuenca' }, { code: 'Girona', name: 'Girona' }, { code: 'Granada', name: 'Granada' }, { code: 'Guadalajara', name: 'Guadalajara' }, { code: 'Guipúzcoa', name: 'Guipúzcoa' }, { code: 'Huelva', name: 'Huelva' }, { code: 'Huesca', name: 'Huesca' }, { code: 'Jaén', name: 'Jaén' }, { code: 'La Rioja', name: 'La Rioja' }, { code: 'Las Palmas', name: 'Las Palmas' }, { code: 'León', name: 'León' }, { code: 'Lleida', name: 'Lleida' }, { code: 'Lugo', name: 'Lugo' }, { code: 'Madrid', name: 'Madrid' }, { code: 'Málaga', name: 'Málaga' }, { code: 'Murcia', name: 'Murcia' }, { code: 'Navarra', name: 'Navarra' }, { code: 'Ourense', name: 'Ourense' }, { code: 'Palencia', name: 'Palencia' }, { code: 'Pontevedra', name: 'Pontevedra' }, { code: 'Salamanca', name: 'Salamanca' }, { code: 'Santa Cruz de Tenerife', name: 'Santa Cruz de Tenerife' }, { code: 'Segovia', name: 'Segovia' }, { code: 'Sevilla', name: 'Sevilla' }, { code: 'Soria', name: 'Soria' }, { code: 'Tarragona', name: 'Tarragona' }, { code: 'Teruel', name: 'Teruel' }, { code: 'Toledo', name: 'Toledo' }, { code: 'Valencia', name: 'Valencia' }, { code: 'Valladolid', name: 'Valladolid' }, { code: 'Vizcaya', name: 'Vizcaya' }, { code: 'Zamora', name: 'Zamora' }, { code: 'Zaragoza', name: 'Zaragoza' }
    ];

    function populateStateDropdown(options, placeholder) {
        stateSelect.innerHTML = '';
        const placeholderOption = new Option(placeholder, "");
        placeholderOption.disabled = true;
        placeholderOption.selected = true;
        stateSelect.add(placeholderOption);
        options.forEach(option => stateSelect.add(new Option(option.name, option.code)));
    }

    function handleCountryChange() {
        const selectedCountry = countrySelect.value;
        if (selectedCountry === 'US') {
            stateWrapper.style.display = 'block';
            populateStateDropdown(usStates, 'Select State');
            stateSelect.required = true;
        } else if (selectedCountry === 'CA') {
            stateWrapper.style.display = 'block';
            populateStateDropdown(canadianProvinces, 'Select Province');
            stateSelect.required = true;
        } else if (selectedCountry === 'ES') {
            stateWrapper.style.display = 'block';
            populateStateDropdown(spanishProvinces, 'Select Province');
            stateSelect.required = true;
        } else {
            stateWrapper.style.display = 'none';
            stateSelect.required = false;
            stateSelect.innerHTML = '';
        }
    }

    // --- MODULE 3: API FUNCTIONS ---
    async function validateAmazonOrder() {
        const orderId = orderInput.value.trim();
        const marketplace = marketplaceSelect.value;
        const pageHandle = form.dataset.pageHandle || 'unknown';
        if (!orderId) {
            messageDiv.textContent = 'Please enter your order number.';
            messageDiv.style.color = 'red';
            return false;
        }
        nextBtn.disabled = true;
        messageDiv.textContent = 'Checking your order...';
        try {
            const response = await fetch('https://server.vantamo.com/api/check-order', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ amazonOrderId: orderId, marketplace: marketplace, pageHandle: pageHandle })
            });
            if (!response.ok) throw new Error(`Server error: ${response.status}`);
            const data = await response.json();
            if (data.status === 'valid') {
                messageDiv.textContent = data.message || 'Order successfully verified!';
                messageDiv.style.color = 'green';
                return true;
            } else {
                messageDiv.innerHTML = "We couldn't verify your Order Number. Please contact us via email <a href='mailto:support@vantamo.com'>support@vantamo.com</a>";
                messageDiv.style.color = 'red';
                return false;
            }
        } catch (error) {
            console.error('API request failed:', error);
            messageDiv.innerHTML = "We couldn't verify your Order Number. Please contact us via email <a href='mailto:support@vantamo.com'>support@vantamo.com</a>";
            messageDiv.style.color = 'red';
            return false;
        } finally {
            nextBtn.disabled = false;
        }
    }

    async function submitFinalOrder() {
        submitBtn.disabled = true;
        
        // --- Collect form data ---
        const amazonOrderId = document.getElementById('amazon-order-input').value.trim();
        
        // Get marketplace ID and name
        const marketplaceSelect = document.getElementById('store');
        const selectedMarketplaceOption = marketplaceSelect.options[marketplaceSelect.selectedIndex];
        const marketplaceId = selectedMarketplaceOption.value;
        const marketplaceName = selectedMarketplaceOption.textContent; // Наприклад, "Amazon.com"

        const buyerAcceptsMarketing = document.getElementById('check1').checked;
        const buyerAcceptsShippingDetails = false; // Removed checkbox
        const pageHandle = form.dataset.pageHandle || 'unknown';
        const warrantyVariantId = form.dataset.warrantyVariantId;
        const selectedWarrantyName = form.dataset.warrantyName;

        let payload;

        if (noGiftCheckbox.checked) {
            // --- NO GIFT scenario (warranty only) ---
            const customerInfo = {
                firstName: document.getElementById('name').value,
                lastName: document.getElementById('surname').value,
                email: document.getElementById('email').value
            };
            
            payload = {
                amazonOrderId: amazonOrderId,
                marketplace: marketplaceId,
                marketplaceName: marketplaceName, // <-- Додано
                pageHandle: pageHandle,
                wantsGift: false,
                warrantyVariantId: warrantyVariantId,
                selectedWarrantyName: selectedWarrantyName,
                customerInfo: customerInfo,
                buyerAcceptsMarketing: buyerAcceptsMarketing,
                buyerAcceptsShippingDetails: 'no'
            };

        } else {
            // --- WITH GIFT scenario (gift + warranty) ---
            // Get phone number in E.164 format using intl-tel-input
            let fullPhoneNumber = "";
            try {
                fullPhoneNumber = iti.getNumber();
                if (!fullPhoneNumber && phoneInput.value.trim()) {
                    const countryData = iti.getSelectedCountryData();
                    fullPhoneNumber = `+${countryData.dialCode}${phoneInput.value.trim()}`;
                }
            } catch (error) {
                console.warn('intl-tel-input error:', error);
                const rawPhone = phoneInput.value.trim();
                if (rawPhone) {
                    if (rawPhone.startsWith('+')) {
                        fullPhoneNumber = rawPhone;
                    } else {
                        const country = document.getElementById('country').value;
                        const countryDialCodes = {
                            'US': '+1', 'CA': '+1', 'GB': '+44', 'DE': '+49', 
                            'ES': '+34', 'IT': '+39', 'FR': '+33'
                        };
                        const dialCode = countryDialCodes[country] || '+1';
                        fullPhoneNumber = `${dialCode}${rawPhone}`;
                    }
                }
            }

            const shippingInfo = {
                firstName: document.getElementById('name').value,
                lastName: document.getElementById('surname').value,
                email: document.getElementById('email').value,
                phone: fullPhoneNumber,
                address1: document.getElementById('address').value,
                city: document.getElementById('city').value,
                zip: document.getElementById('zipcode').value,
                country: document.getElementById('country').value,
                province: document.getElementById('state').value
            };

            const selectedGiftRadio = document.querySelector('input[name="gift"]:checked');
            const selectedGiftName = selectedGiftRadio.value;
            const giftVariantId = selectedGiftRadio.dataset.variantId;

            payload = {
                amazonOrderId: amazonOrderId,
                marketplace: marketplaceId,
                marketplaceName: marketplaceName, 
                pageHandle: pageHandle,
                wantsGift: true,
                giftVariantId: giftVariantId,
                warrantyVariantId: warrantyVariantId,
                selectedGiftName: selectedGiftName,
                selectedWarrantyName: selectedWarrantyName,
                engravingText: personalizationYes.checked ? document.getElementById('engraving').value : null,
                shippingInfo: shippingInfo,
                buyerAcceptsMarketing: buyerAcceptsMarketing,
                buyerAcceptsShippingDetails: 'no'
            };
        }


        
        // --- Send request ---
        try {
            const response = await fetch('https://server.vantamo.com/api/submit-order', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (!response.ok) throw new Error(`Server error: ${response.status}`);
            const data = await response.json();
            if (data.success === true) {
                return true;
            } else {
                alert("We couldn't verify your Order Number. Please contact us via email support@vantamo.com");
                return false;
            }
        } catch (error) {
            console.error('Final submit failed:', error);
            alert("We couldn't verify your Order Number. Please contact us via email support@vantamo.com");
            return false;
        } finally {
            submitBtn.disabled = false;
        }
    }

    // --- MODULE 4: EVENT HANDLERS (CONTROLLER) ---
    function updateFormRequirements() {
        const isNoGift = noGiftCheckbox.checked;
        giftRadios.forEach(radio => radio.required = !isNoGift);
        const requiredShippingFields = ['phone', 'country', 'state', 'address', 'city', 'zipcode'];
        requiredShippingFields.forEach(id => {
            const element = document.getElementById(id);
            if (element) element.required = !isNoGift;
        });
    }
    
    function validateCurrentStep() {
        let isValid = true;
        const activeStepDiv = steps[currentStep];
        const requiredInputs = activeStepDiv.querySelectorAll('[required]');
        for (const input of requiredInputs) {
            if (input.offsetParent !== null && !input.checkValidity()) {
                input.reportValidity();
                isValid = false;
                break;
            }
        }
        return isValid;
    }
    
    nextBtn.addEventListener('click', async () => {
        if (!validateCurrentStep()) return;
        let canProceed = false;
        if (currentStep === 0) {
            canProceed = await validateAmazonOrder();
        } else if (currentStep === 1) {
            canProceed = true;
        }
        if (canProceed && currentStep < 2) {
            currentStep++;
            showStep(currentStep);
        }
    });
    
    prevBtn.addEventListener('click', () => {
        if (currentStep > 0) {
            currentStep--;
            showStep(currentStep);
        }
    });
    
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (!validateCurrentStep()) return;
        const success = await submitFinalOrder();
        if (success) {
            currentStep++;
            showStep(currentStep);
        }
    });
    
    form.addEventListener('input', function(event) {
        if (event.target.id === 'phone') {
            if (!isItiReady) return;
        }
    });

    // --- Other UI event handlers ---
    countrySelect.addEventListener('change', handleCountryChange);
    noGiftCheckbox.addEventListener('change', () => {
        toggleShippingFields();
        if (noGiftCheckbox.checked) giftRadios.forEach(radio => radio.checked = false);
        updateFormRequirements();
    });
    giftRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            if (radio.checked) noGiftCheckbox.checked = false;
            toggleShippingFields();
            updateFormRequirements();
        });
    });
    personalizationYes.addEventListener('change', toggleEngravingInput);
    personalizationNo.addEventListener('change', toggleEngravingInput);

    // --- Marketplace selection popup logic ---
    function populateMarketplaceModal() {
        marketplaceList.innerHTML = '';
        const options = marketplaceSelect.querySelectorAll('option');
        const currentlySelectedValue = marketplaceSelect.value;
        options.forEach(option => {
            if (!option.value) return;
            const item = document.createElement('div');
            item.className = 'gift_marketplace-item';
            item.dataset.value = option.value;
            if (option.value === currentlySelectedValue) {
                item.classList.add('selected');
            }
            item.innerHTML = `
                <img src="${option.dataset.img}" alt="${option.textContent}">
                <span class="gift_item-name">${option.textContent}</span>
                <div class="gift_radio-dot"></div>
            `;
            marketplaceList.appendChild(item);
        });
    }

    marketplaceTrigger.addEventListener('click', () => {
        populateMarketplaceModal();
        modalOverlay.classList.add('active');
    });

    modalOverlay.addEventListener('click', (e) => {
        if (e.target === modalOverlay) {
            modalOverlay.classList.remove('active');
        }
    });
    
    if (modalCloseBtn) {
        modalCloseBtn.addEventListener('click', () => {
            modalOverlay.classList.remove('active');
        });
    }

    marketplaceList.addEventListener('click', (e) => {
        const selectedItem = e.target.closest('.gift_marketplace-item');
        if (!selectedItem) return;
        const value = selectedItem.dataset.value;
        marketplaceSelect.value = value;
        const triggerSpan = marketplaceTrigger.querySelector('span');
        const triggerImg = marketplaceTrigger.querySelector('img');
        const selectedOption = marketplaceSelect.options[marketplaceSelect.selectedIndex];
        triggerSpan.textContent = selectedOption.textContent;
        triggerImg.src = selectedOption.dataset.img;
        triggerImg.style.display = 'inline-block';
        updateFindOrderLink();
        updateAmazonStoreLink();
        modalOverlay.classList.remove('active');
    });



    // --- MODULE 5: INITIAL STARTUP ---
    showStep(currentStep);
    updateFindOrderLink();
    updateAmazonStoreLink();
    toggleEngravingInput();
    toggleShippingFields();
    updateFormRequirements();
    handleCountryChange();
});